import React, { useState } from "react";

import { styled } from "../../../../stitches.config";
import { bodyLarge, h1, h3, h4, p } from "../../../../redesign/commonStyles/Fonts";
import CopyButton from "../../../../redesign/components/CopyButton";
import useMediaQuery from "../../../../helpers/useMediaQuery";

import ArrowBox from "../../../../redesign/assets/icons/arrow-up.svg";
import BackgroundImageMobile from "../../../../redesign/assets/images/contact-1.jpeg";
import BackgroundImageDesktop from "../../../../redesign/assets/images/contact-1.jpeg";
import AddressImageMobile from "../../../../redesign/assets/images/contact-2.jpeg";
import AddressImageDesktop from "../../../../redesign/assets/images//contact-2.jpeg";
import PatronageImageDesktop from "../../../../redesign/assets/images/contact-3.jpeg";
import Footer from "../../../../redesign/components/Footer"

import Avatar from "../../../../redesign/atoms/Avatar";
import { ReactComponent as BackgroundInnEmpty } from "../../../../redesign/assets/innpolandRedesign/footer-inn-empty-gray.svg?react"

export interface Boxes {
    box1?: boolean,
    box2?: boolean,
    box3?: boolean,
    box4?: boolean,
    box5?: boolean,
}
const ContactInnpoland: React.FC<Boxes> = ({
    box1 = false,
    box2 = false,
    box3 = false,
    box4 = false,
    box5 = false,
}) => {
    const [isActive1, setActive1] = useState(box1);
    const [isActive2, setActive2] = useState(box2);
    const [isActive3, setActive3] = useState(box3);
    const [isActive4, setActive4] = useState(box4);
    const [isActive5, setActive5] = useState(box5);
    const toggleClass1 = () => {
        setActive1(!isActive1);
    };
    const toggleClass2 = () => {
        setActive2(!isActive2);
    };
    const toggleClass3 = () => {
        setActive3(!isActive3);
    };
    const toggleClass4 = () => {
        setActive4(!isActive4);
    };
    const toggleClass5 = () => {
        setActive5(!isActive5);
    };
    const isDesktop = useMediaQuery('bp4');
    return (
        <>
            <StyledContactWrapper>
                <BackgroundLogo>
                    <BackgroundInnEmpty />
                </BackgroundLogo>
                <StyledContact>
                    <Info>
                        <h1>Kontakt</h1>
                        <InfoContainer>
                            <ContactInfoBox className="first-box">
                                <h2 onClick={toggleClass2}>Redakcja<span className={isActive2 ? "active-arrow arrow-box" : "arrow-box"}></span></h2>
                                <ContentBox className={isActive2 ? "active" : ""}>
                                    <div className={bodyLarge()}>
                                        <Avatar border={true} size={isDesktop ? "extrabig" : "normal"} src="https://m.innpoland.pl/b312878abbae29bdc58b9c05b246a541,656,656,1,0.jpg" />
                                        <p>Grzegorz Szymanik</p>
                                        <p>Redaktor prowadzący</p>
                                        <CopyButton text="grzegorz.szymanik@innpoland.pl" />
                                    </div>
                                </ContentBox>
                            </ContactInfoBox>
                            <ContactInfoBox>
                                <h2 onClick={toggleClass3}>Reklama<span className={isActive3 ? "active-arrow arrow-box" : "arrow-box"}></span></h2>
                                <ContentBox className={isActive3 ? "active" : ""} contain={true}>
                                    <div className={bodyLarge()}>
                                        <Avatar border={true} size={isDesktop ? "extrabig" : "normal"} src="https://m.natemat-staging.jadwiga.easysoftware.pl/e60ce6ad3610708d070867f614422e93,780,0,0,0.jpg" />
                                        <p>Justyna Rzeniewicz</p>
                                        <p>Dyrektor Działu Reklamy</p>
                                        <CopyButton text="justyna.rzeniewicz@natemat.pl" />
                                    </div>
                                </ContentBox>
                            </ContactInfoBox>
                        </InfoContainer>
                    </Info>
                    <BackgroundImage>
                        <img className="desktop" src={BackgroundImageDesktop} />
                        <img className="mobile" src={BackgroundImageMobile} />
                    </BackgroundImage>
                    <Description>
                        <div>
                            <h1 className={h1()}>Poznaj nasz zespół</h1>
                            <p className={p()}>
                                Jeśli chcesz wiedzieć, jak się z nami pracuje, zapraszamy do zakładki Kariera w Grupie naTemat.
                            </p>
                            <a className={h4()} href="/kariera">Kariera w na:Temat
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.9131 0.297043L15.6159 5.99984L9.9131 11.7026L8.78172 10.5713L12.5529 6.80007H0.466553V5.20007L12.5534 5.20007L8.78172 1.42841L9.9131 0.297043ZM0.666553 6.60007L13.0358 6.60007L9.06457 10.5713L9.9131 11.4198L9.91321 11.4197L9.06476 10.5712L13.036 6.60004L0.666748 6.60004L0.666748 5.40007H0.666553V6.60007ZM9.06457 1.42841L13.0362 5.40004H13.0364L9.06476 1.42838L9.91318 0.579966L9.9131 0.579886L9.06457 1.42841Z" />
                                </svg>
                            </a>
                        </div>
                    </Description>
                    <Address>
                        <img className="desktop" src={AddressImageDesktop} />
                        <ContactInfoBox>
                            <h3 onClick={toggleClass4} className={h3()}>
                                <span>Redakcja INN<span className="primary">:</span>Poland</span>
                                <span className={isActive4 ? "active-arrow arrow-box" : "arrow-box"}></span>
                            </h3>
                            <ContentBox className={isActive4 ? "active content-box" : "content-box"}>
                                <div className={bodyLarge()}>
                                    <p className="small-text">Adres:</p>
                                    <p>Fabryka Koronek</p>
                                    <p>ul. Burakowska 5/7,</p>
                                    <p>01-066 Warszawa</p>
                                </div>
                                <div className={bodyLarge()}>
                                    <p className="small-text">Kontakt:</p>
                                    <div className="small-margin-copy-btn">
                                        <CopyButton text="kontakt@innpoland.pl" />
                                    </div>
                                    <p>tel. 884 999 790</p>
                                    <p>tel. 881 666 627</p>
                                </div>
                            </ContentBox>
                        </ContactInfoBox>
                    </Address>
                    <Patronage>
                        <ContactInfoBox>
                            <h2 onClick={toggleClass5}>Patronaty<span className={isActive5 ? "active-arrow arrow-box" : "arrow-box"}></span></h2>
                            <ContentBox className={isActive5 ? "active" : ""}>
                                <div className={bodyLarge()}>
                                    <p className="margin-bottom">Zachęcamy do kontaktu w kwestii patronatów na:Temat</p>
                                    <CopyButton text="patronaty@natemat.pl" />
                                </div>
                            </ContentBox>
                        </ContactInfoBox>
                        <img className="desktop" src={PatronageImageDesktop} />
                    </Patronage>
                    <img className="mobile" src={AddressImageMobile} />
                </StyledContact >
            </StyledContactWrapper>
            <Footer />
        </>
    );
};

const StyledContactWrapper = styled("div", {
    position: "relative",
    width: "100%",
})

const StyledContact = styled("div", {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "$grayscale0",
    maxWidth: "1440px",
    margin: "0 auto",
    ".primary": {
        color: "$primary",
    },
    ".desktop": {
        display: "none",
        "@bp4": {
            display: "block",
        }
    },
    ".mobile": {
        "@bp4": {
            display: "none",
        }
    },
    ".active": {
        maxHeight: "3000px",
        transition: "0.5s",
    },
    ".arrow-box": {
        transform: "rotate(180deg)",
        width: "14px",
        height: "8px",
        marginLeft: "auto",
        backgroundImage: `url("${ArrowBox}")`,
        backgroundPosition: "right",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        display: "inline-block",
        transition: "0.3s",
        "@bp4": {
            display: "none",
        }
    },
    ".active-arrow": {
        transform: "rotate(0deg)"
    },
    "div": {
        color: "$grayscale100"
    }
});

const BackgroundLogo = styled("div", {
    position: "absolute",
    left: "-70px",
    top: "100px",
    width: "300px",
    height: "300px",
    display: "none",
    "@bp4": {
        display: "block",
    },
    "svg": {
        stroke: "$primary",
        transform: "rotate(90deg)",
    }
});


const Info = styled("div", {
    padding: "40px 16px 16px 16px",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    "@bp4": {
        padding: "120px 84px 112px 55px",
        marginLeft: "192px",
        flexDirection: "row",
        justifyContent: "space-between",
        borderLeft: "1px solid rgba(19,18,18, .1)",
        borderOpacity: "0.1",
        flexWrap: "wrap",
    },
    "h1": {
        margin: "0 0 32px 0",
        fontFamily: "$grotesk",
        fontWeight: "700",
        fontSize: "54px",
        lineHeight: "62px",
        letterSpacing: "0px",
        "@bp4": {
            margin: "0 32px 32px 0",
        }
    }
});


const InfoContainer = styled("div", {
    display: "flex",
    flexDirection: "column",
    "@bp4": {
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-between",
        maxWidth: "676px",
    },
    ".first-box": {
        "@bp4": {
            marginRight: "56px",
        }
    }
});

const ContactInfoBox = styled("div", {
    "@bp4": {
        width: "300px",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
    },
    "h2": {
        fontFamily: "$grotesk",
        fontSize: 24,
        lineHeight: "30px",
        letterSpacing: "0.2px",
        fontWeight: "700",
        paddingBottom: "16px",
        borderBottom: "1px solid $grayscale100",
        margin: "0 0 16px 0",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    "p": {
        margin: "0 0 4px 0",
    },
    "div": {
        marginBottom: "16px",
        "@bp4": {
            width: "300px",
        },
    },
    ".small-text": {
        fontSize: 16,
        lineHeight: "24px",
        color: "$grayscale75",
        margin: "0 0 6px 0",
    },
    ".small-margin-copy-btn": {
        marginBottom: "4px",
        "div": {
            marginBottom: "0px",
        }
    }
});

//

const BackgroundImage = styled("div", {
    width: "100%",
    "@bp4": {
        width: "calc(100% - 84px)",
        marginRight: "84px",
    },
    "img": {
        width: "100%",
    },
    ".mobile": {
        "@bp2": {
            display: "none",
        }
    },
    ".desktop": {
        display: "none",
        "@bp2": {
            display: "block",
        }
    }
});

//

const Description = styled("div", {
    margin: "0 16px",
    "@bp4": {
        margin: "0 84px",
        borderRight: "1px solid rgba(19,18,18, .1)",
    },

    "div": {
        "@bp4": {
            maxWidth: "840px",
            margin: " 0 auto",
        },
        "h1": {
            margin: "40px 0 0 0",
            "@bp4": {
                margin: "96px 0 0 0",
            },
        },
        "p": {
            margin: "16px 0 24px 0",
            "@bp4": {
                margin: "24px 0 40px 0",
            }
        },
        "a": {
            color: "$primary",
            "svg": {
                marginLeft: "8px",
                display: "inline-block",
                "path": {
                    fill: "$primary",
                }
            }
        }
    }
});

const ContentBox = styled("div", {
    maxHeight: "0px",
    overflow: "hidden",
    transition: "0.5s",
    "@bp4": {
        maxHeight: "3000px",
        display: "flex",
        justifyContent: "space-between",
        width: "100% !important",
    },
    "& .avatar": {
        width: "72px",
        height: "72px",
        marginRight: "14px",
        flexShrink: 0,
        "@bp4": {
            width: "112px",
            height: "112px",
            marginRight: 0,
        }
    },
    variants: {
        contain: {
            true: {
                "& .avatar img": {
                    objectFit: 'contain'
                }
            },
            false: {}
        }
    }
});

//

const Address = styled("div", {
    margin: "0 16px",
    "@bp4": {
        display: "flex",
        alignItems: "center",
        margin: "0 84px",
        padding: "110px 64px 120px 0",
        borderRight: "1px solid rgba(19,18,18, .1)",
    },
    "img": {
        width: "100%",
        "@bp2": {
            width: "calc(100% - 364px)",
            marginRight: "64px",
            maxWidth: "840px"
        }
    },
    "h3": {
        paddingBottom: "16px",
        borderBottom: "1px solid $grayscale100",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "@bp4": {
            borderBottom: "0px solid $grayscale100",
            paddingBottom: "0px",
            display: "block",
        }
    },
    ".content-box": {
        "@bp4": {
            flexDirection: "column"
        }
    }
});

const Patronage = styled("div", {
    margin: "0 16px",
    "@bp4": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "0 0 0 84px",
    },
    "img": {
        width: "100%",
        "@bp2": {
            width: "calc(100% - 468px)",
            maxWidth: "898px",
        }
    },
    ".margin-bottom": {
        marginBottom: "16px",
    }
});

export default ContactInnpoland;